import React, { useContext, useEffect, useState } from 'react';
import {IsLoggedContext, PlanContext} from '../Store'
import {Link} from 'react-router-dom'
import '../styles/styles.css'
import { config } from '../server'
import { useAuth0 } from '@auth0/auth0-react';
import TutorProfile from './TutorProfile'
const address = config.url.API_URL

const Profile = () => {
	const [isLogged] = useContext(IsLoggedContext)
	const [studyNames, setStudyNames] = useState([])
	const [spaces, setSpaces] = useState([])
	const [plan ,setPlan] = useContext(PlanContext)
	const { user, isAuthenticated, isLoading, logout } = useAuth0();
    const [name, setName] = useState('')

	const handleLogout = (e) => {
		setPlan('')
		logout({ returnTo: 'https://clusterfy.app/sign-up' })
	}

	useEffect(() => {
		fetch(address + '/api/getSets').then(res => res.json()).then(data => {
		// console.log(data)
		const data2 = data.allDocs
		let vals = []
		let vals2 = []
		for(let i = 0; i < data.allDocs.length; i++) {
			if(data2[i].name === isLogged){
			vals.push(data2[i].studyTitle)
			vals2.push(data2[i].topicName)
			}
		}

		const unique = new Set(vals)
		const newUnique = [...unique]
		setStudyNames(newUnique)





		});
		const requestOptions = {
		method: 'POST',
		headers: { 
			'content-type': 'application/json' },
		body: JSON.stringify({ owner: isLogged })
	};
		fetch(address + '/api/spaceOwners', requestOptions).then(res => res.json()).then(data => {
		setSpaces(data.userSpaces)
		});

		const getName = async () => {
			const response = await fetch(address + `/api/${user.email}/getUser`)
        	const data1 = await response.json()
			setName(data1.name)
		}
		getName()

	}, [isLogged, user.email]);

	/*const sendMail = (link) => {
	const tempVars = {
		to_email: 'keeperpaige@gmail.com',
		to_name: 'andrew',
		reply_to: 'keeperpaige@gmail.com',
		message: link
	}
	//alert(link)
	window.emailjs.send(
		process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_CANCEL_LINK_ID,
		  tempVars
		  ).then(() => {
			alert('Email successfully sent!')
		  })
		  // Handle errors here however you like, or use a React error boundary
		  .catch(() => alert('Sorry, there was an error when sending your email'))
	}*/
	

	/*const handleRedirect = async (e) => {
		e.preventDefault()
		const requestOptions = {
			method: 'POST',
			headers: { 
			'content-type': 'application/json' }
		};
		const response = await fetch(`${address}/create-customer-portal-session`, requestOptions);
		const data = await response.json()
		window.location.href = data.portalSession
		//window.location.replace(data.portalSession);
		//sendMail(data.portalSession)
	}*/

	if (isLoading) {
		return <div>Loading ...</div>;
	  }

	  const handleName = async (e) => {
		  e.preventDefault()
		const requestOptions1 = {
		  method: 'POST',
		  headers: { 
		  'content-type': 'application/json' },
		  body: JSON.stringify({ name: name, email: user.email })
		};
		const res = await fetch(address + '/api/signUp', requestOptions1)
		const data = await res.json()
		if(data.status === 'success') {
			alert('Name saved!')
		}
	  }

	return(
	    isAuthenticated && (
		 <div>
			
			{plan !== 'tutor' && 
				<div className="heroContainer">
				<div className="level-item">
					<img src={user.picture} alt="profile" />
				</div>
					{name.length < 1 && <h1>Role: Learner</h1>}
					{name.length > 0 && <h1>{name}</h1>}
					<h2>{user.name}</h2>
				</div>
			}
			{ plan === 'tutor' && <TutorProfile /> }
			{ plan !== 'tutor' && <div className="subNav">
			<form onSubmit={handleName}>
			<label>Enter your name</label>
			<br/>
			<input type="text" className="input" placeholder="Please enter a name" 
			style={{width: '50%'}} value={name} onChange={e => setName(e.target.value)} />
			<button className="subNavBtn" type="submit">Save</button>
			</form>
				<button className="subNavBtn" onClick={e => handleLogout(e)}>Log Out</button>
			</div> }



		<div style={{paddingBottom: '2%'}} className="level-item">
			<h1>My Sets</h1>
		</div>
	<div className="level-item">
		<div className="column is-6">
		{studyNames.map((setNames,i) => (
			<ul key={i}>
			<li key={i}>
			<div key={i}>
			<div key={i} className="card">
				<header key={i+1} className="card-header">
				<p className="card-header-title">
				<Link className="link" to={ {
				pathname: `${setNames}`}}>{setNames}</Link>
				</p>
			</header>
		</div>
			</div>
			</li>
		</ul>
		))}
		</div>
		</div>

		<div style={{paddingBottom: '2%'}} className="level-item">
			<h1>My Spaces</h1>
		</div>
		<div className="level-item">
		<div className="column is-6">
		{spaces.map((space,i) => (
			<ul key={i}>
			<li key={i}>
			<div key={i}>
			<div key={i} className="card">
				<header key={i+1} className="card-header">
				<p className="card-header-title">
				<Link className="link" to={`/space/${space.spaceName}`}>{space.spaceName}</Link>
				</p>
			</header>
		</div>
			</div>
			</li>
		</ul>
		))}
		</div>
		</div>

	
	</div>
		)
	)
}


export default Profile